<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(name='close' size="small" @click.native="closeModal()")

    main.modal-main
        header.modal-header
            SectionHeader(title="New partner")

        div.modal-body

            div.form-subsection--between
                div.form-label
                    label.form-section-title.flex-1 Select partner
                    div.form-section-subtitle Choose a partner to add a Dsp
                .form-subsection-row
                    select.form-select.big.square(v-model="dspLabel")
                        option(v-if="selectedDsp === null" value="null" disabled hidden) Select an existing partner
                        option(
                            v-for="item in dspList"
                            :key="item.id",
                            :label="item.label"
                            :value="item.keyLabel"
                        ) {{ item.label }}

            template(v-if="dspLabel !== null")
                //- LABEL
                div.form-subsection(
                    v-if="(dspLabel === 'datahub' && haveCustomer) || dspLabel !== 'datahub'"
                )
                    div.form-label__required
                        label(for="label") {{ ['tiktok', 'datahub'].includes(dspLabel)  ? 'Label' : 'Partner name'}}
                    input.form-input(
                        :key="dspLabel"
                        v-model="dspInfo.label"
                        :placeholder="`Choose a nice ${ ['tiktok', 'datahub'].includes(dspLabel)  ? 'label' : 'name' } for your dsp`"
                        :autofocus="dspLabel !== null"
                        id="label"
                        name="label"
                        data-vv-name="label"
                        v-validate="'max:200|required|ascii'"
                        type="text")
                    span.form-validate-error {{ errors.first('label') }}
                //- DATAHUB
                template(v-if="dspLabel === 'datahub'")
                    template(v-if="haveCustomer")
                        div.form-subsection
                            div.form-label
                                label(for="namespace_id") Namespace
                            select.form-select.big(
                                id="namespace_id"
                                name="namespace_id"
                                v-model="datahubExtraInfo.namespace_id")
                                option(v-if="datahubExtraInfo.namespace_id === null" hidden) Choose namespace
                                option(
                                    v-for="item in datahubExtraInfoNamespaces",
                                    :key="item.id",
                                    :value="item.id") {{ item.label }}
                        div.form-subsection
                            div.form-label
                                label(for="email-key") Email key (sha256)
                            input.form-input(
                                id="email-key"
                                name="email-key"
                                placeholder="Email key (sha256)"
                                v-model="datahubExtraInfo.email_sha_256_key"
                                v-validate="'ascii'")
                            span.form-validate-error {{ errors.first('email-key') }}
                        div.form-subsection
                            div.form-label
                                label(for="phone-key") Phone key (sha256)
                            input.form-input(
                                id="phone-key"
                                name="phone-key"
                                placeholder="Phone key (sha256)"
                                v-model="datahubExtraInfo.phone_sha_256_key"
                                v-validate="'ascii'")
                            span.form-validate-error {{ errors.first('phone-key') }}
                    div(v-else)
                        p No customer linked to this account.

                //- TIKTOK USER ID
                div.form-subsection(v-if="dspLabel === 'tiktok'")
                    div.form-label__required
                        label(for="tiktok-user-id") Tiktok user id for weborama
                    input.form-input(
                        :key="dspLabel"
                        v-model="tiktokExtraInfo.oauth2_user_id"
                        placeholder="Id of the weborama account in tiktok account (digits only)"
                        :autofocus="dspLabel !== null"
                        id="tiktok-user-id"
                        name="user id"
                        v-validate="identifierRule"
                        type="text")
                    span.form-validate-error {{ errors.first('user id') }}

                //- DPS CLIENT ID
                //- email only
                template(v-if="dspClientIdEmail")
                    div.form-subsection(v-if="dspLabel === dspKeyLabels.adobe")
                        div.form-label__required
                            label(for="dsp_adobe_email") Adobe Account Email
                        input.form-input(
                            :key="dspLabel"
                            v-model="dspClientId"
                            placeholder="Set your DSP Account Email"
                            autofocus
                            id="dsp_adobe_email"
                            type="text")
                        span.form-validate-error(v-if="adobeDspClientIdNotCorrect") Must be a valid adobe or tubemogul address

                    div.form-subsection(v-else-if="dspLabel === dspKeyLabels.mailRu")
                        div.form-label__required.l-flex-row--between
                            label(for="email") Email
                            div.counter(style="margin-right: 50px" v-show="mailRuEmailList.length !== 0") {{ mailRuEmailList.length }}/5
                        EmailCcField(
                            parent="DspForm"
                            placeholder="Set your DSP Account Email"
                            @formCcListUpdate="updateFormCcList"
                            :maxItems="5"
                        )

                //- digits only
                div.form-subsection(v-if="dspClientIdDigit")
                    div.form-label__required
                        label(for="dsp_id") {{ labelDspClientId }}
                    input.form-input(
                        :key="dspLabel"
                        v-model="dspClientId"
                        :placeholder="`Set your ${ dspLabel === 'tiktok' ? 'Ad' : 'DSP'} Account ID (digits only)`"
                        :autofocus="dspLabel !== null"
                        id="dsp_id"
                        :name="dspLabel === 'tiktok' ? 'ad account id' : 'dsp_id'"
                        v-validate="identifierRule"
                        type="text")
                    span.form-validate-error {{ errors.first(dspLabel === 'tiktok' ? 'ad account id' : 'dsp_id') }}

                //- ascii only
                div.form-subsection(v-if="dspClientIdAscii")
                    div.form-label__required
                        label(for="dsp_ascii") {{ dspIdAsciiToDisplay }}
                    input.form-input(
                        :key="dspLabel"
                        v-model="dspClientId"
                        placeholder="Set your DSP Account ID"
                        autofocus
                        id="dsp_ascii"
                        name="dsp_ascii"
                        data-vv-name="dsp_ascii"
                        v-validate="'max:255|required|ascii'"
                        type="text")
                    span.form-validate-error {{ errors.first('dsp_ascii') }}


                //- EXTRA INFO
                //- AppNexus && Google DMP
                div.form-subsection(v-if="isExtraInfo && dspLabel !== dspKeyLabels.facebook ")
                    div.form-label__required
                        label(for="extra-info") {{ extraInfoToDisplay }}
                    select.form-select.big(
                        :key="dspLabel"
                        id="extra-info"
                        name="extra-info"
                        placeholder="Select a config type"
                        v-model="extraInfoType")
                        option(
                            v-for="item in extraInfoTypes",
                            :key="item.id",
                            :value="item.id") {{ item.label }}

                div.form-subsection(v-if="isExtraInfo && dspLabel === dspKeyLabels.googleDdp ")
                    div.form-label__required
                        label(for="extra-info") Partner account id (ClientID)
                    input.form-input(
                        :key="dspLabel"
                        v-model="googleDDPExtraInfo.partner_account_id"
                        placeholder="Set your partner Account ID"
                        autofocus
                        id="partner-account-id"
                        name="partner-account-id"
                        data-vv-name="partner-account-id"
                        v-validate="'required|max:19|ascii|decimal:no'"
                        type="text")
                    span.form-validate-error {{ errors.first('partner-account-id') }}

                //- The Trade Desk
                div.form-subsection(v-if="theTradeDeskFirstParty")
                    div.form-label__required
                        label(for="secret_key") Secret key
                    input.form-input(
                        :key="dspLabel"
                        v-model="dspInfo.extra_info"
                        placeholder="Set your secret key"
                        autofocus
                        id="secret_key"
                        name="secret_key"
                        data-vv-name="secret_key"
                        v-validate="'max:255|alpha_num|required'"
                        type="text"
                    )
                    span.form-validate-error {{ errors.first('secret_key') }}

                //- Generic DSP
                div.form-subsection(v-if="dspLabel === dspKeyLabels.genericDsp")
                    div.form-label
                        label(for="template") Template
                    input.form-input(
                        :key="dspLabel"
                        v-model="dspInfo.extra_info"
                        placeholder="Set your template"
                        autofocus
                        id="template"
                        name="template"
                        v-validate="'max:255'"
                        type="text")
                    span.form-validate-error {{ errors.first('template') }}

                //- Facebook
                template(v-if="dspLabel === dspKeyLabels.facebook")
                    div.form-subsection
                        div.form-label__required
                            label(for="facebook-crm-field") CRM field
                        input.form-input(
                            :key="'crm_field'"
                            v-model="fb_id_pattern"
                            autofocus
                            id="crm_field"
                            name="crm_field"
                            v-validate="'max:255|required'"
                            type="text")
                        span.form-validate-error {{ errors.first('crm_field') }}
                    div.form-subsection
                        div.form-label__required
                            label(for="facebook-crm-namespace") CRM namespace
                        select.form-select.big(
                            id="facebook-crm-namespace"
                            name="facebook-crm-namespace"
                            v-model="facebookExtraInfoCrmNamespace")
                            option(
                                v-for="item in facebookExtraInfoCrmNamespaceTypes",
                                :key="item.id",
                                :value="item") {{ item.label }}

                //- TRANSFER TYPE
                div.form-subsection(v-if="isTransferType")
                    div.form-label__required
                        label(for="transfer-type") Transfer Type
                    select.form-select.big(
                        :key="dspLabel"
                        id="transfer-type"
                        name="transfer-type"
                        v-model="transferType"
                        placeholder="Select your transfer type")
                        option(
                            v-for="item in transferTypes",
                            :key="item.id",
                            :label="item.label",
                            :value="item.id") {{ item.label }}

                //- SHARING RECORD (RUBICON)
                div.form-subsection(v-if="dspLabel === dspKeyLabels.rubicon")
                    div.form-label__required
                        label(for="sharing_record_id") Publisher API ID's
                    input.form-input(
                        :key="dspLabel"
                        v-model="sharingRecordId"
                        placeholder="Publisher API ID's"
                        autofocus
                        id="sharing_record_id"
                        name="sharing_record_id"
                        v-validate="'decimal:no|required'"
                        type="number")
                    span.form-validate-error {{ errors.first('sharing_record_id') }}

                //- Account TYPE
                div.form-subsection(v-if="dspLabel === 'pubmatic'")
                    div.form-label__required
                        label(for="transfer-type") Account Type
                    el-select(
                        :key="dspLabel"
                        id="account-type"
                        name="account-type"
                        v-model="pubmaticAccountType"
                        placeholder="Select your transfer type")
                        el-option(
                            v-for="item in pubmaticAccountTypes",
                            :key="item.id",
                            :label="item.label",
                            :value="item.id") {{ item.label }}

                //- Snapchat
                template(v-if="dspLabel === 'snapchat'")
                    div.form-subsection
                        div.form-label__required
                            label(for="ad-account-id") Snapchat ad account id
                        input.form-input(
                            id="ad-account-id"
                            name="ad-account-id"
                            placeholder="Snapchat ad account id"
                            v-model="dspClientId"
                            v-validate="'required|ascii'")
                        span.form-validate-error {{ errors.first('ad-account-id') }}
                    div.form-subsection
                        div.form-label__required
                            label(for="namespace_id") Namespace
                        select.form-select.big(
                            id="namespace_id"
                            name="namespace_id"
                            v-model="snapchatExtraInfo.namespace_id")
                            option(
                                v-for="item in snapchatExtraInfoNamespaces",
                                :key="item.id",
                                :value="item.id") {{ item.label }}
                    div.form-subsection
                        div.form-label__required
                            label(for="email-key-sha256") Email key (sha256)
                        input.form-input(
                            id="email-key-sha256"
                            name="email-key-sha256"
                            placeholder="Email key (sha256)"
                            v-model="snapchatExtraInfo.email_sha_256_key"
                            v-validate="'required|ascii'")
                        span.form-validate-error {{ errors.first('email-key-sha256') }}

                //- TIKTOK
                template(v-if="dspLabel === 'tiktok'")
                        div.form-subsection
                            div.form-label__required
                                label(for="identifier") Identifier
                            select.form-select.big(
                                id="identifier"
                                name="Identifier"
                                :disabled="true"
                                v-model="tiktokExtraInfo.id_type")
                                option(
                                    v-for="item in tiktokIdentifierList",
                                    :key="item",
                                    :value="item") {{ item }}
                        div.form-subsection
                            div(:class="tiktokClassNameByRule")
                                label(for="namespace_id") Namespace
                            select.form-select.big(
                                id="namespace_id"
                                name="Namespace"
                                placeholder="Select a namespace"
                                v-validate="tiktokExtraInfoRule"
                                v-model="tiktokExtraInfo.namespace_id")
                                option(
                                    v-for="item in getNamespacesCRM()",
                                    :key="item.id",
                                    :label="item.label"
                                    :value="item.id")
                            span.form-validate-error {{ errors.first('Namespace') }}
                        div.form-subsection
                            div(:class="tiktokClassNameByRule")
                                label(for="crm-key") CRM key
                            input.form-input(
                                id="crm-key"
                                name="CRM key"
                                placeholder="CRM key"
                                v-model="tiktokExtraInfo.crm_key"
                                v-validate="tiktokExtraInfoRule")
                            span.form-validate-error {{ errors.first('CRM key') }}
        //- FOOTER
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev(:class="{'is-disabled': disableSave }" @click="addDsp()") Add partner
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { find, get, isEmpty, isEqual, isNil, join, size } from 'lodash'
import { Validator } from 'vee-validate'

import { DSP_KEY_LABELS } from '@/utils/constants'

import SectionHeader from '@/components/common/SectionHeader'
import EmailCcField from '@/components/common/EmailCcField'

export default {
    name: 'DspForm',

    components: { SectionHeader, EmailCcField },

    watch: {
        dspLabel: {
            handler: function(newVal, oldVal) {
                if (!isEqual(newVal, oldVal)) {
                    this.resetForm(oldVal)
                    this.clearErrors()
                }
            }
        },
        deep: true
    },

    created() {
        const dict = {
            custom: {
                'partner-account-id': {
                    required: 'The Partner account id field is required',
                    max: 'The Partner account id should contain less than 19 characters',
                    decimal: 'The Partner account id field must be numeric and may contain no decimal points'
                },
            }
        }
        this.$validator.localize('en', dict)
    },

    mounted() {
        let _selectedDspLabel = null
        if (!isNil(this.selectedDsp)) {
            const _dsp = find(this.dspList, _dsp => _dsp.id === this.selectedDsp)
            _selectedDspLabel = _dsp.keyLabel
        }
        this.dspLabel = _selectedDspLabel
        const dictionary = {
            en: {
                messages:{
                    regex: 'The Identifier on partner field should allow only numbers from 0-9'
                }
            }
        }
        Validator.localize(dictionary)
    },

    data() {
        return {
            dspLabel: null,
            dspInfo: {
                label: '',
                extra_info: ''
            },
            dspClientId: '',
            mailRuDspClientId: '',
            mailRuEmailList: [],
            transferType: '1stparty',
            transferTypes: [
                { id: '1stparty', label: '1st party' },
                { id: '3rdparty', label: '3rd party' }
            ],
            pubmaticAccountType: 'BUYER',
            pubmaticAccountTypes: [
                { id: 'BUYER', label: 'Buyer' },
                { id: 'PUBLISHER', label: 'Publisher' },
                { id: 'DEMAND_PARTNER', label: 'Demand partner' }
            ],
            sharingRecordId: '',
            appNexusExtraInfo: 'seat_id',
            googleDMPExtraInfo: 'DFP_BY_GOOGLE',
            facebookExtraInfoCrmNamespace: {
                namespace_id: null,
                namespace_pattern: ''
            },
            snapchatExtraInfo: {
                namespace_id: null,
                email_sha_256_key: null
            },
            fb_id_pattern: '',
            processing: false,
            // TIKTOK
            tiktokIdentifierList: ['Email', 'Phone', 'MAID'],
            tiktokExtraInfo: {
                namespace_id: null,
                id_type: 'Email',
                crm_key: '',
                oauth2_user_id: '',
                is_authenticated: false
            },

            datahubExtraInfo: {
                namespace_id: null,
                email_sha_256_key: '',
                phone_sha_256_key: '',
            },

            googleDDPExtraInfo: {
                partner_account_type: 'GOOGLE_AD_MANAGER',
                partner_account_id: ''
            }
        }
    },

    computed: {
        ...mapGetters('ui/dsp', ['getSimpleDspList']),
        ...mapGetters('account', ['getNamespacesCRM', 'haveCustomer', 'getCustomer']),
        ...mapState('ui/dsp', {
            selectedDsp: state => state.selectedDsp
        }),
        facebookExtraInfo() {
            return {
                fb_id_pattern: this.fb_id_pattern,
                namespace_id: this.facebookExtraInfoCrmNamespace.id,
                namespace_pattern: this.facebookExtraInfoCrmNamespace.pattern
            }
        },
        cmpExtraInfo() {
            if (this.dspLabel === this.dspKeyLabels.facebook) return this.facebookExtraInfo

            return this.isExtraInfo ? this.extraInfoType : this.theTradeDeskThirdParty ? '' : this.dspInfo.extra_info
        },
        dspKeyLabels() {
            return DSP_KEY_LABELS
        },
        dspList() {
            return this.getSimpleDspList().map((dsp) => {
                if (dsp.keyLabel === 'gam') {
                    dsp.label = 'Google GAM PPID'
                }
                return dsp
            })
        },
        facebookExtraInfoCrmNamespaceTypes() {
            return this.getNamespacesCRM()
        },
        snapchatExtraInfoNamespaces() {
            return this.getNamespacesCRM()
        },
        datahubExtraInfoNamespaces() {
            return this.getNamespacesCRM()
        },
        commonDisableSave() {
            return isEmpty(this.dspInfo.label) || isEmpty(this.dspClientId) || this.errors.count() > 0
        },
        disableSave() {
            if (this.dspLabel === null) {
                return true
            }
            if (this.dspLabel === this.dspKeyLabels.adobe) {
                return this.commonDisableSave || this.adobeDspClientIdNotCorrect
            }
            if (this.dspLabel === this.dspKeyLabels.rubicon) {
                return this.commonDisableSave || isEmpty(this.sharingRecordId)
            }
            if (this.dspLabel === this.dspKeyLabels.theTradeDesk) {
                return this.theTradeDeskFirstParty ? this.commonDisableSave || isEmpty(this.dspInfo.extra_info) : this.commonDisableSave
            }
            if (this.dspLabel === this.dspKeyLabels.mailRu) {
                return isEmpty(this.dspInfo.label) || isEmpty(this.mailRuEmailList) || this.errors.count() > 0
            }
            if (this.dspLabel === this.dspKeyLabels.facebook) {
                return (
                    this.facebookExtraInfoCrmNamespace.id == null ||
                    isEmpty(this.fb_id_pattern) ||
                    this.errors.count() > 0 ||
                    this.commonDisableSave ||
                    this.processing
                )
            }
            if(this.dspLabel === this.dspKeyLabels.snapchat) {
                return (
                    this.snapchatExtraInfo.namespace_id == null ||
                    this.snapchatExtraInfo.email_sha_256_key == null ||
                    this.errors.count() > 0
                )
            }
            if(this.dspLabel === this.dspKeyLabels.tiktok) {
                return (
                    this.tiktokExtraInfo.namespace_id === null ||
                    this.tiktokExtraInfo.crm_key === '' ||
                    this.errors.count() > 0 ||
                    this.commonDisableSave
                )
            }

            if(this.dspLabel === this.dspKeyLabels.datahub) {
                return (
                    /**
                     this.datahubExtraInfo.namespace_id === null ||
                     this.datahubExtraInfo.email_sha_256_key === '' ||
                     this.datahubExtraInfo.phone_sha_256_key === '' ||
                     */
                    this.errors.count() > 0 ||
                    isEmpty(this.dspInfo.label)
                )
            }

            if (this.dspLabel === this.dspKeyLabels.googleDdp) {
                return (
                    this.errors.count() > 0 ||
                    isEmpty(this.googleDDPExtraInfo.partner_account_id) ||
                    isEmpty(this.googleDDPExtraInfo.partner_account_type)
                )
            }
            return this.commonDisableSave || this.processing
        },
        isTransferType() {
            return this.dspLabel === this.dspKeyLabels.adobe || this.dspLabel === this.dspKeyLabels.theTradeDesk
        },

        //client id
        theTradeDeskFirstParty() {
            return this.dspLabel === this.dspKeyLabels.theTradeDesk && this.transferType === '1stparty'
        },
        theTradeDeskThirdParty() {
            return this.dspLabel === this.dspKeyLabels.theTradeDesk && this.transferType === '3rdparty'
        },
        dspClientIdAscii() {
            return (
                this.theTradeDeskFirstParty ||
                this.theTradeDeskThirdParty ||
                this.dspLabel === this.dspKeyLabels.rubicon ||
                this.dspLabel === this.dspKeyLabels.smartAdServer ||
                this.dspLabel === this.dspKeyLabels.utiqEquativ ||
                this.dspLabel === this.dspKeyLabels.yandex
            )
        },
        dspClientIdDigit() {
            if (
                this.dspLabel !== this.dspKeyLabels.theTradeDesk && this.dspLabel !== this.dspKeyLabels.snapchat && this.dspLabel !== this.dspKeyLabels.datahub
            ) return !this.dspClientIdEmail && !this.dspClientIdAscii
            else return null
        },
        dspClientIdEmail() {
            return this.dspLabel === this.dspKeyLabels.adobe || this.dspLabel === this.dspKeyLabels.mailRu
        },
        isRuEmailList() {
            const arrayEmails = this.mailRuDspClientId.split(/[,]+/)
            return size(arrayEmails) !== 1
        },
        dspIdEmailToDisplay() {
            if (this.dspLabel === this.dspKeyLabels.adobe) return 'Adobe Account Email'
            if (this.dspLabel === this.dspKeyLabels.mailRu) return 'Email'
            return 'Account ID'
        },
        dspIdAsciiToDisplay() {
            if (this.dspLabel === this.dspKeyLabels.smartAdServer || this.dspLabel === this.dspKeyLabels.utiqEquativ) return 'Public Segment Provider ID'
            if (this.dspLabel === this.dspKeyLabels.yandex) return 'Acl'
            return 'Account ID'
        },
        adobeDspClientIdNotCorrect() {
            if (isEmpty(this.dspClientId)) return false
            const regex = /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@(adobe|tubemogul)\.com$/
            return this.dspLabel === this.dspKeyLabels.adobe && !regex.test(this.dspClientId)
        },

        //extra info
        isExtraInfo() {
            return this.dspLabel === this.dspKeyLabels.appNexus || this.dspLabel === this.dspKeyLabels.facebook || this.dspLabel === this.dspKeyLabels.googleDmp || this.dspLabel === this.dspKeyLabels.googleDdp
        },
        extraInfoToDisplay() {
            if (this.dspLabel === this.dspKeyLabels.appNexus || this.dspLabel === this.dspKeyLabels.googleDmp) return 'Config Type'
            else if (this.dspLabel === this.dspKeyLabels.googleDdp) return 'Partner account type'
            return null
        },
        extraInfoType: {
            get() {
                if (this.dspLabel === this.dspKeyLabels.appNexus) return this.appNexusExtraInfo
                if (this.dspLabel === this.dspKeyLabels.googleDmp) return this.googleDMPExtraInfo
                if (this.dspLabel === this.dspKeyLabels.googleDdp) return this.googleDDPExtraInfo.partner_account_type
                return this.facebookExtraInfo
            },
            set(val) {
                if (this.dspLabel === this.dspKeyLabels.appNexus) this.appNexusExtraInfo = val
                else if (this.dspLabel === this.dspKeyLabels.googleDmp) this.googleDMPExtraInfo = val
                else if (this.dspLabel === this.dspKeyLabels.googleDdp) this.googleDDPExtraInfo.partner_account_type = val
            }
        },

        identifierRule() {
            const rules = {
                required: true,
                decimal: 'no',
                max: '6',
                regex: /^([0-9]+)$/,
            }
            if (this.dspLabel === this.dspKeyLabels.pubmatic) {
                rules.max = '6'
                return rules
            }
            if (this.dspLabel === this.dspKeyLabels.googleDdp) {
                rules.max = '200'
                return rules
            }
            if (rules.max) delete rules.max
            return rules
        },

        extraInfoTypes() {
            if (this.dspLabel === this.dspKeyLabels.appNexus) {
                return [
                    {
                        id: 'seat_id',
                        label: 'Seat id'
                    },
                    {
                        id: 'advertiser_id',
                        label: 'Advertiser id'
                    }
                ]
            }
            if (this.dspLabel === this.dspKeyLabels.googleDmp) {
                return [
                    {
                        id: 'DFP_BY_GOOGLE',
                        label: 'GAM'
                    },
                    {
                        id: 'INVITE_ADVERTISER',
                        label: 'DV360 Advertiser'
                    },
                    {
                        id: 'INVITE_PARTNER',
                        label: 'DV360 Partner'
                    },
                    {
                        id: 'ADWORDS',
                        label: 'Google Ads'
                    }
                ]
            }
            if (this.dspLabel === this.dspKeyLabels.googleDdp) {
                return [
                    {
                        id: 'GOOGLE_AD_MANAGER',
                        label: 'GAM'
                    },
                    {
                        id: 'DISPLAY_VIDEO_ADVERTISER',
                        label: 'DV360 Advertiser'
                    },
                    {
                        id: 'DISPLAY_VIDEO_PARTNER',
                        label: 'DV360 Partner'
                    },
                ]
            }

            return null
        },

        tiktokExtraInfoRule() {
            if (this.tiktokExtraInfo.id_type !== 'Email') return
            return 'required'
        },
        tiktokClassNameByRule() {
            return this.tiktokExtraInfo.id_type === 'Email' ? 'form-label__required' : 'form-label'
        },
        labelDspClientId() {
            if(this.dspLabel === this.dspKeyLabels.tiktok) {
                return 'Ad account id'
            }
            if(this.dspLabel === this.dspKeyLabels.googleDdp) {
                return 'DDP account Id'
            }
            return 'Identifier on partner'
        }
    },

    methods: {
        ...mapMutations('ui/dsp', ['setDisplayModal']),
        ...mapActions('data/accountsDsps', ['createAccountsDsp']),

        closeModal() {
            this.processing = false
            this.setDisplayModal({ item: 'form', display: false })
        },

        addDsp() {
            let extraInfoTypeData = this.extraInfoType
            if (this.processing) return // Prevent multiple creation

            let _dspClientId = this.dspClientId
            this.processing = true
            const displayExtraInfo = this.isExtraInfo || this.dspLabel === this.dspKeyLabels.pubmatic || this.dspLabel === this.dspKeyLabels.datahub || this.dspLabel === this.dspKeyLabels.snapchat || this.dspLabel === this.dspKeyLabels.tiktok  || this.dspLabel === this.dspKeyLabels.googleDdp

            if (this.dspLabel === this.dspKeyLabels.mailRu) {
                _dspClientId = join(this.mailRuEmailList, ',')
            }

            if (this.dspLabel === this.dspKeyLabels.googleDdp) {
                extraInfoTypeData = {
                    ...this.googleDDPExtraInfo
                }
            }

            if (this.dspLabel === this.dspKeyLabels.appNexus) {
                extraInfoTypeData = { apx_clientid_type: this.appNexusExtraInfo }
            }

            if (this.dspLabel === this.dspKeyLabels.pubmatic) {
                extraInfoTypeData = { account_type: this.pubmaticAccountType }
            }

            if (this.dspLabel === this.dspKeyLabels.facebook) {
                extraInfoTypeData = this.extraInfoType
            }

            if (this.dspLabel === this.dspKeyLabels.snapchat) {
                extraInfoTypeData = this.snapchatExtraInfo
            }

            if (this.dspLabel == this.dspKeyLabels.tiktok) {
                this.tiktokExtraInfo.namespace_id = +this.tiktokExtraInfo.namespace_id
                extraInfoTypeData = {
                    ...this.tiktokExtraInfo,
                    id_type: this.tiktokExtraInfo.id_type === 'Email' ? 'EMAIL_SHA256' : this.tiktokExtraInfo.id_type,
                }
            }

            if (this.dspLabel === this.dspKeyLabels.datahub) {
                const datahubExtraInfo = {}

                if(this.datahubExtraInfo.namespace_id !== null) {
                    datahubExtraInfo.namespace_id = this.datahubExtraInfo.namespace_id
                }
                if(this.datahubExtraInfo.email_sha_256_key !== '') {
                    datahubExtraInfo.email_sha_256_key = this.datahubExtraInfo.email_sha_256_key
                }
                if(this.datahubExtraInfo.phone_sha_256_key !== '') {
                    datahubExtraInfo.phone_sha_256_key = this.datahubExtraInfo.phone_sha_256_key
                }

                extraInfoTypeData = {
                    ...datahubExtraInfo
                }
                _dspClientId = this.getCustomer && this.getCustomer.id ? this.getCustomer.id : 1
            }

            const _dspInfos = {
                ...this.dspInfo,
                dsp_id: get(
                    find(this.dspList, dsp => dsp.keyLabel === this.dspLabel),
                    'id',
                    ''
                ),
                dsp_client_id: _dspClientId,
                sharing_record_id: this.dspLabel === this.dspKeyLabels.rubicon ? this.sharingRecordId : 0,
                transfer_type: this.isTransferType ? this.transferType : '1stparty',
                extra_info: displayExtraInfo ? extraInfoTypeData : this.theTradeDeskThirdParty ? '' : this.dspInfo.extra_info
            }

            this.createAccountsDsp(_dspInfos).then(response => {
                if (response === 'success') {
                    this.closeModal()
                }
                this.processing = false
            })
        },
        updateFormCcList(ccList) {
            this.mailRuEmailList = ccList
        },
        mailRuDspClientIdNotCorrect(emailList) {
            if (!isEmpty(emailList)) {
                if (this.isRuEmailList) {
                    const arrayEmails = emailList.split(/[,]+/)
                    for (const email of arrayEmails) {
                        if (!RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{2,3}').test(email)) return true
                    }
                } else {
                    return !RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]{2,3}').test(emailList)
                }
            }
        },
        clearErrors() {
            this.$validator.pause()
            this.$nextTick(() => {
                this.$validator.errors.clear()
                this.$validator.fields.items.forEach(field => field.reset())
                this.$validator.fields.items.forEach(field => this.errors.remove(field))
                this.$validator.resume()
            })
        },
        resetForm(oldDspLabel) {
            this.dspInfo = {
                label: '',
                extra_info: ''
            }
            this.dspClientId = ''
            this.mailRuDspClientId = ''
            this.appNexusExtraInfo = 'seat_id'
            this.googleDMPExtraInfo = 'DFP_BY_GOOGLE'
            this.googleDDPExtraInfo.partner_account_type = 'GOOGLE_AD_MANAGER'
            this.googleDDPExtraInfo.partner_account_id = ''
            this.sharingRecordId = ''
            this.transferType = '1stparty'

            if (oldDspLabel === this.dspKeyLabels.adobe) {
                const regex = /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@(adobe|tubemogul)\.com$/
                if (!regex.test(this.dspClientId) || this.errors.count() > 0) this.clearErrors()
            }
            // reset dspClientId after regex check
            this.dspClientId = ''
            if (oldDspLabel !== this.dspKeyLabels.adobe && this.errors.count() > 0) this.clearErrors()
        }
    }
}
</script>
